module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dqqna"))).then(() => parcelRequire('dFSGc'));